// src/components/PopupManager.tsx
import React from "react";
import { usePopupManager } from "../hooks/usePopupManager";
import { Popup } from "../../../atoms/Popup";

interface PopupManagerProps {
  trigger?: number;
  isOpen?: boolean;
  onClose?: () => void;
  popupProps?: object;
}

const PopupManager: React.FC<PopupManagerProps> = ({ trigger, isOpen, onClose }) => {
  const { popupProps, setVisible, setTrigger } = usePopupManager();

  // Sync props from parent if provided
  React.useEffect(() => {
    if (typeof trigger === "number") setTrigger(trigger);
    if (typeof isOpen === "boolean") setVisible(isOpen);
  }, [trigger, isOpen, setVisible, setTrigger]);

  return (
    <Popup
      destroyOnClose={true}
      {...popupProps}
      onCancel={() => {
        onClose?.();
      }}
    />
  );
};

export default PopupManager;
